import React from "react";
import { Table, Button, Tooltip, message } from "antd";
import coin1 from "assets/img/coin1.png";
import coin2 from "assets/img/coin2.png";
import coin3 from "assets/img/coin3.png";
import BarChart from "components/charts/BarChart";
import moment from "moment";
import axios from "axios";
import { mcqSubjectNames } from "services/utility";
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Progress,
  Row,
  FormGroup,
  Input,
  Label,
  CardHeader,
} from "reactstrap";
import Widget04 from "components/Widgets/Widget04";
import { connect } from "react-redux";
// import { addParams } from 'store/route-params/actions';
import apiurl from "../../../../apiurl";

const mapDispatchToProps = (dispatch) => ({
  // addParams: (payload) => {
  //   dispatch(addParams(payload));
  // }
});
const mapStateToProps = (state) => {
  const user = state.user;
  return {
    schoolId: user && user.school_id,
  };
};

class DynamicGradeTab extends React.Component {
  constructor(props) {
    super(props);
    this.chartReference = React.createRef();
    this.state = {
      gradeDetails: "",
      totalGradeStudentCount: "",
      searchname: "",
    };
  }

  async viewSubjectDetail(obj) {
    let subjectName = obj.subject;
    let subjectId = obj.subjectId;
    let gradeId = localStorage.getItem("selectedGrade_id");
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let path = `/subject-detail`;
    this.props.history.push({
      pathname: path,
      state: {
        type: subjectName,
        schoolId: finalSchool_id,
        gradeId: gradeId,
        subjectId: subjectId,
      },
    });
  }

  getStudentDetail(selectedRowKeys, selectedRows) {
    console.log(selectedRows);
    let selectedUser_id = selectedRows.user_id;
    let selectedGrade_id = localStorage.getItem("selectedGrade_id"); // Grade ID
    // let login_data = JSON.parse(localStorage.getItem('login_data'));
    let selectedBoard_id = localStorage.getItem("finalBoard_id"); // Board ID
    let boardIdOtherGrades = localStorage.getItem("boardIdOtherGrades"); // Board ID Other Grade
    let selectedGrade_Name = localStorage.getItem("selectedGrade_Name");
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let boardName = selectedRows.boardName;
    let payload;
    if (selectedGrade_id_statisticApi === "") {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: boardIdOtherGrades,
        grade: selectedGrade_Name,
        filter: "day",
        param: "all",
      };
    } else {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        grade: selectedGrade_Name,
        filter: "day",
      };
    }
    // this.props.addParams(payload);
    // alert("pp")
    // this.props.history.push('/dashboard/student-detail');
    this.props.history.push({
      pathname: "/student-detail",
      state: {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        boardName: boardName,
        grade: selectedGrade_Name,
        filter: "day",
        param: payload.param !== undefined ? payload.param : "",
      },
    });
    window.scrollTo(0, 0);
  }

  async reIndexData(selectedRowKeys, selectedRows) {
    let selectedUser_id = selectedRows.user_id;
    console.log(selectedUser_id);
    if (selectedUser_id === undefined) {
      message.error("Indexing failed user id not found");
    } else {
      const payload = {
        id: selectedUser_id,
      };
      let url =
        "https://8ytwl5trrl.execute-api.ap-south-1.amazonaws.com/PROD/process-user-lrs";
      let res = await axios.post(url, payload);
      console.log(res);
      message.success("Indexing successfull");
    }
  }
  handleTableChange = (pagination, filters, sorter) => {
    console.log("PROPS", this.props);
    this.props.onClickTbl(this.props, pagination);
  };

  searchBarUpdate(e) {
    this.setState({
      searchname: e.target.value,
    });
  }

  searchStudentInfo() {
    let searchname = this.state.searchname;
    this.props.onSearchClick(searchname, 1);
  }

  resetStudentInfoTbl() {
    this.props.onResetClick(this.props);
    this.setState({
      searchname: "",
    });
  }

  async downloadCsv() {
    try {
      let gradeId = localStorage.getItem("selectedGrade_id");
      let finalSchool_id = localStorage.getItem("finalSchool_id");
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let selectedGrade_Name = localStorage.getItem("selectedGrade_Name");
      let playedGradeId = localStorage.getItem("playedGradeId");
      let downloadCsvResult;
      console.log("SCHOOLid", finalSchool_id);
      if (
        selectedGrade_id_statisticApi === "" ||
        selectedGrade_id_statisticApi === null
      ) {
        downloadCsvResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/downloadgradecsv-dev",
          {
            schoolId: finalSchool_id,
            gradeId: gradeId,
            grade: selectedGrade_Name,
            param: "all",
            playedGradeId: playedGradeId,
          }
        );
      } else {
        downloadCsvResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/downloadgradecsv-dev",
          {
            schoolId: finalSchool_id,
            gradeId: gradeId,
            grade: selectedGrade_Name,
            playedGradeId: playedGradeId,
          }
        );
      }
      downloadCsvResult = downloadCsvResult.data;
      window.open(downloadCsvResult.path, "_blank"); //to open new page
    } catch (e) {
      console.log(e);
    }
  }

  async getbarLabelData(val, lbl) {
    // let selectedGrade_RomanVal = localStorage.getItem('selectedGrade_RomanVal');
    // let path = `/principal/students`;
    // this.props.history.push({
    //   pathname: path,
    //   state: {
    //     category:'simplebar-studentlist',
    //     barlabelval: val,
    //     type: 'simplebar-stulist',
    //     cardTitle: 'List of Students in grade ' + selectedGrade_RomanVal + ' with ' + val + ' % ',
    //   }
    // });
  }

  render() {
    let ovsPercentage = [];
    let ovStudentCount = [];
    let gradeDetails = this.props.gradeDetails;
    let totalGradeStudentCount =
      gradeDetails !== undefined && gradeDetails !== ""
        ? gradeDetails.Grade.stats.students
        : "";
    let gradeOverallScoreArr =
      gradeDetails !== undefined && gradeDetails !== ""
        ? gradeDetails.Grade.stats.score.overall_score
        : [];
    let gradeSubjects =
      gradeDetails !== undefined && gradeDetails !== ""
        ? gradeDetails.Grade.subjects
        : "";
    let studentListing = this.props.gradeDetails;
    let studentListingData =
      studentListing !== undefined && studentListing !== ""
        ? studentListing.Grade.length !== 0
          ? studentListing.Grade.stats.gradewise_student_score
          : ""
        : "";
    let gradeWiseStudentTblData = this.props.gradeWiseStudentTblData;
    let gradeWiseStudentTblDataFinal =
      gradeWiseStudentTblData !== undefined ? gradeWiseStudentTblData : "";
    console.log(gradeWiseStudentTblData);

    for (let i = 0; i < gradeOverallScoreArr.length; i++) {
      ovsPercentage.push(gradeOverallScoreArr[i].Percent);
      ovStudentCount.push(gradeOverallScoreArr[i].StudentCount);
    }
    const result = {
      status: "success",
      message: "",
      data: {
        role: "school",
        user: {
          user_id: 2952092,
          user_name: "BhupeshKV",
          first_name: "Bhupesh",
          last_name: "Bhatt",
          user_email: "kv2kalaikunda@gmail.com",
          user_mobile: "09953496776",
        },
        school: { school_id: 1828, school_name: "KV Kalaikunda No.2" },
        board: { board_id: 7, board_name: "CBSE" },
        grade: [],
      },
    };
    localStorage.setItem("login_data", JSON.stringify(result));

    let role = JSON.parse(localStorage.getItem("login_data"));
    console.log(role.data.role);
    let finalRole = role.data.role;

    const gradeWiseStudentListTblcolumns = [
      // {
      //   title: 'User Id',
      //   dataIndex: 'user_id',
      //   key: 'user_id',
      // render: (selectedRowKeys, selectedRows) => (
      // <a href onClick={()=>this.getStudentDetail(selectedRowKeys, selectedRows)}>{selectedRowKeys}</a>
      // ),
      // },
      {
        title: "Full Name",
        dataIndex: "fullname",
        key: "fullname",
      },
      {
        // title: 'User Grade',
        title: (
          <Tooltip>
            User Grade&nbsp;{" "}
            <Tooltip title="It denotes the class/grade in school.">
              {" "}
              <icon
                className="icon-inform text-icon dash-icon-inform"
                aria-hidden="true"
              ></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "userGrade",
        key: "userGrade",
        align:"center",
      },
      {
        title: "Knowledge Wealth",
        // title:  <Tooltip> Score (%) &nbsp;<Tooltip title="It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively."> <icon className="icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
        dataIndex: "total_knowledge_wealth",
        align:"right",
        key: "total_knowledge_wealth",
        render: (text) => (
          <span>{Math.round(text)}</span>
          // <div className="gcoin_css gcoin_dmd">
          //   <img src={coin1} alt="dimond images" height={50} />
          //   <span className="coin_nums">{text}</span>
          // </div>
        ),
      },
      {
        // title: 'Knowledge Wealth',
        title: (
          <Tooltip>
            {" "}
            Score (%) &nbsp;&nbsp;&nbsp;{" "}
            <Tooltip title="It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively.">
              {" "}
              <icon
                className="icon-inform text-icon dash-icon-inform"
                aria-hidden="true"
              ></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "knowledge_wealth",
        key: "knowledge_wealth",
        align:"right",
        render: (text) => (
          <span>{text} %</span>
          // <div className="gcoin_css gcoin_dmd">
          //   <img src={coin1} alt="dimond images" height={50} />
          //   <span className="coin_nums">{text}</span>
          // </div>
        ),
      },

      {
        // title: 'Knowledge Currency',
        title: (
          <Tooltip>
            {" "}
            Knowledge Efficiency (%)&nbsp;
            <Tooltip title="It measures the learning outcomes of the chapter-end quiz, where the student's conceptual clarity of all topics within that chapter is tested from the total score of 100.">
              {" "}
              <icon
                className="icon-inform text-icon dash-icon-inform"
                aria-hidden="true"
              ></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "knowledge_currency",
        align:"right",
        key: "knowledge_currency",
        render: (text) => (
          <span>{text} %</span>
          // <div className="gcoin_css">
          //   <img src={coin2} alt="dimond images" height={50} />
          //   <span className="coin_nums">{text}</span>
          // </div>
        ),
      },
      {
        // title: 'Learning Currency',
        title: (
          <Tooltip>
            {" "}
            Learning Efficiency (%) &nbsp;&nbsp;&nbsp;{" "}
            <Tooltip title="It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100.">
              {" "}
              <icon
                className="icon-inform text-icon dash-icon-inform"
                aria-hidden="true"
              ></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "learning_currency",
        key: "learning_currency",
        align:"right",
        render: (text) => (
          <span>{text} %</span>
          // <div className="gcoin_css">
          //   <img src={coin3} alt="dimond images" height={50} />
          //   <span className="coin_nums">{text}</span>
          // </div>
        ),
      },
      // {
      //   title: 'Grade Rank',
      //   dataIndex: 'global_rank',
      //   key: 'global_rank',
      // },
      // {
      //   title: 'Time Alloted',
      //   dataIndex: 'time_alloted',
      //   key: 'time_alloted',
      // },
      {
        title: "Chapters Completed",
        dataIndex: "completedChapterCount",
        key: "completedChapterCount",
        align: "center",
      },
      {
        // title: 'Time Spend',
        title: (
          <Tooltip>
            Time Spent&nbsp;{" "}
            <Tooltip title="It denotes the total time spent by the student in answering the questions in the app in the format hr: min: sec from the available time of 30 seconds per question.">
              {" "}
              <icon
                className="icon-inform text-icon dash-icon-inform"
                aria-hidden="true"
              ></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "time_spend",
        key: "time_spend",
        render: (text) => (
          <span>{moment.utc(text * 1000).format("HH:mm:ss")}</span>
        ),
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        align: "right",
        render: (selectedRowKeys, selectedRows) => (
          <Button
            className="btn btn-outline "
            onClick={() => this.getStudentDetail(selectedRowKeys, selectedRows)}
          >
            {" "}
            View details <icon className="icon-next"></icon>
          </Button>
        ),
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        render: (selectedRowKeys, selectedRows) =>
          finalRole == "qa" ? (
            <Button
              type="primary"
              className="btn btn-outline "
              onClick={() => this.reIndexData(selectedRowKeys, selectedRows)}
            >
              Reindex
            </Button>
          ) : (
            ""
          ),
      },
    ];

    for (let i = 0; i < studentListingData.length; i++) {
      studentListingData[i].key = i;
    }

    return (
      <Row>
        <Col>
          <div className="row no-gutters py-2">
            <div className="custom-card-stu-count card-shadow width-auto ">
              {/* <Widget04 color="warning" header={totalGradeStudentCount.toString()} value="25">Total Students</Widget04> */}
              <div className="text-white">Total Students</div>
              <div className="student-count-custom text-right">
                {totalGradeStudentCount.toString()}
              </div>
            </div>
          </div>
          {/* -------------------------------------------------------------------------- */}
          <Row>
            <Col md="12">
              <Card>
                <CardHeader className="dash-card-header mb-0">
                  Grade - Wise Student Count &nbsp;&nbsp;{" "}
                  <Tooltip title="The graph represents the count of the total number of students distributed according to their participation in the respective grades.">
                    {" "}
                    <icon
                      className="icon-inform text-icon dash-icon-inform"
                      aria-hidden="true"
                    ></icon>{" "}
                  </Tooltip>
                </CardHeader>
                <CardBody>
                  {/* <CardTitle className="mb-0">Grade - Wise Student Count</CardTitle> */}

                  <div
                    className="chart-wrapper"
                    style={{ marginTop: 40 + "px" }}
                  >
                    <BarChart
                      labels={ovsPercentage}
                      data={ovStudentCount}
                      height={324}
                      onClick={this.getbarLabelData.bind(this)}
                    />
                  </div>
                </CardBody>
                <div className="width-100 col-md-12 student-count-flex">
                  {gradeSubjects &&
                    gradeSubjects.length &&
                    gradeSubjects.map((object, i) => (
                      <div
                        id="subject-cards"
                        className={`student-count-card shadow-md subject-${mcqSubjectNames(
                          object.subject.toLowerCase()
                        )}`}
                        onClick={() => this.viewSubjectDetail(object)}
                      >
                        <div className="card-bg width-100" key={i}>
                          <div className="col-md-12 text-center d-f-c">
                            <icon
                              className={`circle-icon-size icon-${mcqSubjectNames(
                                object.subject.toLowerCase()
                              )}`}
                            />

                            {object.subject}
                          </div>
                          <div className="col-md-12 text-value text-center">
                            {object.StudentCount}
                            {/* Users (40%) */}
                          </div>
                          <div className="col-md-12 text-center">
                            <button className="btn btn-outline-none text-white">
                              View Details
                            </button>
                          </div>
                          {/* <Progress className="progress-xs mt-2 width-100" color="success" value="100" /> */}
                        </div>
                      </div>
                    ))}
                </div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader className="dash-card-header card-header">
                  Students Report
                </CardHeader>
                <CardBody>
                  <div className="row no-gutters mt-2 d-f-c  form-group ">
                    {/* <div className="col-md-4"></div> */}
                    <div className="col-md-6 p-2 text-right">
                      {/* <Label htmlFor="text-input">Search :</Label> */}
                      <Input
                        type="text"
                        id="studentName"
                        name="studentName"
                        placeholder="Search"
                        value={this.state.searchname}
                        onChange={this.searchBarUpdate.bind(this)}
                      />
                    </div>
                    <div className="col-md-6 width-auto searchbuttongrp text-right">
                      <Button
                        type="submit"
                        size="sm"
                        color="primary"
                        onClick={this.searchStudentInfo.bind(this)}
                      >
                        <icon
                          className="icon-search-01"
                          aria-hidden="true"
                        ></icon>
                      </Button>
                      <Button
                        type="submit"
                        size="sm"
                        color="primary"
                        onClick={this.resetStudentInfoTbl.bind(this)}
                      >
                        <icon
                          className="icon-refresh"
                          aria-hidden="true"
                        ></icon>
                      </Button>
                      <Button
                        type="button"
                        size="sm"
                        color="primary"
                        onClick={this.downloadCsv}
                      >
                        <icon
                          className="icon-install"
                          aria-hidden="true"
                        ></icon>
                        <span> &nbsp;csv &nbsp;</span>
                      </Button>
                    </div>
                  </div>
                  <div className="row no-gutters mt-2 width-100 ">
                    <div className="col-md-12">
                      <Table
                        pagination={this.props.pagination}
                        columns={gradeWiseStudentListTblcolumns}
                        dataSource={gradeWiseStudentTblDataFinal}
                        onChange={this.handleTableChange}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DynamicGradeTab);
